import { render, staticRenderFns } from "./Subscriptions.vue?vue&type=template&id=886e5bb2&scoped=true"
import script from "./Subscriptions.vue?vue&type=script&lang=js"
export * from "./Subscriptions.vue?vue&type=script&lang=js"
import style0 from "./Subscriptions.vue?vue&type=style&index=0&id=886e5bb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "886e5bb2",
  null
  
)

export default component.exports